export enum TreatmentState {
  completed = "completed",
  inProgress = "inProgress",
  notStarted = "notStarted",
  interrupted = "interrupted",
  canceled = "canceled",
}

export function getTreatmentState(state: string): TreatmentState {
  switch (state) {
    case "completed":
      return TreatmentState.completed;
    case "inProgress":
      return TreatmentState.inProgress;
    case "notStarted":
      return TreatmentState.notStarted;
    case "interrupted":
      return TreatmentState.interrupted;
    case "canceled":
      return TreatmentState.canceled;
    default:
      console.error("TreatmentState is not valid: " + state);
      return TreatmentState.notStarted;
  }
}
